import { render, staticRenderFns } from "./leaderBoard.vue?vue&type=template&id=58be49e8&"
import script from "./leaderBoard.vue?vue&type=script&lang=js&"
export * from "./leaderBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports